import { Flex, type Icon } from "@chakra-ui/react";
import React from "react";
import { remCalc } from "theme/utils";

export type IconChipColor = "gray" | "green" | "yellow" | "red" | "violet" | "blue";

export type IconChipProps = {
  variant: IconChipColor;
  icon: typeof Icon;
};

export function IconChip({ variant, icon: Icon }: IconChipProps) {
  const bgColor = `new.${variant}.150`;
  const textColor = `new.${variant}.900`;

  return (
    <Flex
      align="center"
      bgColor={bgColor}
      borderRadius="full"
      boxSize={remCalc(48)} // Fixed height avoids fractional pixels being added with icon use
      color={textColor}
      justify="center"
      lineHeight="none" // Reset inherited line heights to avoid icon positioning issues
      p={remCalc(14)}
    >
      <Icon boxSize="icon.md" />
    </Flex>
  );
}
